/**
 * Fachada de servicios (P2.1).
 * Reexporta OrderService, SettingsService, ClientService, TechnicianService
 * para compatibilidad con código existente. Preferir importar el servicio concreto.
 */
import { OrderService } from './orderService';
import { SettingsService } from './settingsService';
import { ClientService } from './clientService';
import { TechnicianService } from './technicianService';

export { bustDashboardStatsCache } from './orderService';

export const DataService = {
    // --- Órdenes (OrderService) ---
    getOrders: OrderService.getOrders.bind(OrderService),
    getDashboardStats: OrderService.getDashboardStats.bind(OrderService),
    getOrderById: OrderService.getOrderById.bind(OrderService),
    createOrder: OrderService.createOrder.bind(OrderService),
    updateOrder: OrderService.updateOrder.bind(OrderService),
    deleteOrder: OrderService.deleteOrder.bind(OrderService),
    deleteEvent: OrderService.deleteEvent.bind(OrderService),
    updateEvent: OrderService.updateEvent.bind(OrderService),

    // --- Settings (SettingsService) ---
    getSettings: SettingsService.getSettings.bind(SettingsService),
    updateSettings: SettingsService.updateSettings.bind(SettingsService),
    completeOnboarding: SettingsService.completeOnboarding.bind(SettingsService),
    deleteAccount: SettingsService.deleteAccount.bind(SettingsService),


    // --- Clientes (ClientService) ---
    getClients: ClientService.getClients.bind(ClientService),
    searchClients: ClientService.searchClients.bind(ClientService),
    createClient: ClientService.createClient.bind(ClientService),
    updateClient: ClientService.updateClient.bind(ClientService),
    addWorkSite: ClientService.addWorkSite.bind(ClientService),
    deleteClient: ClientService.deleteClient.bind(ClientService),

    // --- Técnicos (TechnicianService) ---
    getTechnicians: TechnicianService.getTechnicians.bind(TechnicianService),
    createTechnician: TechnicianService.createTechnician.bind(TechnicianService),
    updateTechnician: TechnicianService.updateTechnician.bind(TechnicianService),
    deleteTechnician: TechnicianService.deleteTechnician.bind(TechnicianService),
};
